import { SEND_ACTIVATION_EMAIL, SendActivationEmail, SendActivationEmailRequestDto } from '../types/activation-email'

export const sendActivationEmail = (payload: SendActivationEmailRequestDto): SendActivationEmail => {
  return {
    type: SEND_ACTIVATION_EMAIL,
    payload,
  }
}
